package team.platforma.multiplatform_material_extension.calendar.properties

class CalendarViewProperties(
    var adaptiveHeight: Boolean = false,
    var animateClickChangeButtonMonth : Boolean = false,
    var animateBadge: Boolean = false
)
